<div>
  <p>
    Todas las preguntas deben responderse con la informacion de la persona
    natural o juridica quien lleva el negocio. Ejemplo, si realiza la
    actividad economica a traves de una sociedad, la informacion es de la
    sociedad
  </p>
</div>
